// src/rtkQuery/features/hooks/usePatientProfileSubmission.ts

import { usePatientInformationService } from "@/rtkQuery/features/hooks/usePatientInformationService";
import type { UpdateProfileSchema } from "@/validation-schemas/update-profile-schemas";
import { toastService } from "@/utils/toastService";

export const usePatientProfileFormSubmission = () => {
    const {
        submitPatientInformation,
        patientPostData,
        patientPostError,
        patientPostIsLoading,
        patientPostIsSuccess,
        patientPostIsError,
        patientPostStatus,
        patientPostErrorMessage,
    } = usePatientInformationService();

    const submitPatientProfile = async (formData: UpdateProfileSchema) => {
        try {
            const payload = {
                ...formData,
                dateOfBirth: formData.dateOfBirth?.toISOString().split("T")[0], // ⬅️ Convert Date → 'YYYY-MM-DD'
            };
            const response = await submitPatientInformation(payload).unwrap();
            if (response.Result) {
                toastService.success("Your profile has been updated successfully.");
            }
            return response;
        } catch (err: any) {
            toastService.error(patientPostErrorMessage);
            throw err;
        }
    };

    return {
        submitPatientProfile,
        isLoading: patientPostIsLoading,
        isSuccess: patientPostIsSuccess,
        isError: patientPostIsError,
        error: patientPostError,
        status: patientPostStatus,
        data: patientPostData,
        errorMessage: patientPostErrorMessage,
    };
};